import axios from "axios";
import baseUrl from "../../utilities/baseUrl";

const useTipax = () => {
  const tipaxRate = async ({
    senderAddressId,
    getterAddressId,
    shipments,
    isCod,
    isBulk,
    postItem,
    totalSpecialService,
    needPrint,
    needSMS,
    needCollecting,
  }) => {
    try {
      const url = baseUrl + "/internalpost/v1/tipaxRate";
      const token = localStorage.getItem("token");

      const response = await axios.post(
        url,
        {
          senderAddressId,
          getterAddressId,
          shipments,
          isCod,
          isBulk,
          internalSectionId: 1,
          totalSpecialService,
          needCollecting,
          collectingType: 1,
          needPrint,
          needSMS,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: "Bearer " + token,
          },
          timeout: 18000,
        }
      );

      if (response.status === 200) {
        return {
          chaparData: response.data.result,
          Data: postItem,
        };
      }
    } catch (error) {
      return { Data: postItem, chaparData: { quote: 0 } };
    }
  };

  return { tipaxRate };
};

export default useTipax;
